import React from "react";
import "./Reccomndation.css";

import Common_Title from "../../../components/common_components/common_title/Common_Title";
import Common_Product_Card from "../../../components/common_components/common_product_card/Common_Product_Card";
import { variant_type } from "../../../utils/common";

const Reccomndation = ({ product }) => {
  const data = [
    {
      img: "/assets/images/home/new_arrival/img1.png",
      discount: 35,
      prodName: "The Allswell Supreme",
      sellingPrice: "4,367.00",
      mrp: "6,719.00",
      emi: "1092",
      rating: "4.8",
      reviews: "189",
      features: [
        "Dual Side usage",
        "Naturally Cooling Coir that refreshens you",
        "Firm back support",
        "Naturally Cooling Coir that refreshens you",
        "Firm back support",
      ],
    },
    {
      img: "/assets/images/home/new_arrival/img1.png",
      discount: 30,
      prodName: "The Allswell Supreme",
      sellingPrice: "4,367.00",
      mrp: "6,719.00",
      emi: "1092",
      rating: "4.8",
      reviews: "189",
      features: [
        "Dual Side usage",
        "Naturally Cooling Coir that refreshens you",
        "Firm back support",
      ],
    },
    {
      img: "/assets/images/home/new_arrival/img1.png",
      prodName: "The Allswell Supreme",
      sellingPrice: "4,367.00",
      mrp: "6,719.00",
      emi: "1092",
      rating: "4.8",
      reviews: "189",
      features: [
        "Qube Cell Technology",
        " 3 Zone Copper Infused NRG Layer ",
        "Zero Motion Transfer for no partner disturbance",
      ],
    },
    {
      img: "/assets/images/home/new_arrival/img1.png",
      prodName: "The Allswell Supreme",
      sellingPrice: "4,367.00",
      mrp: "6,719.00",
      emi: "1092",
      rating: "4.8",
      reviews: "189",
      features: [
        "Qube Cell Technology",
        " 3 Zone Copper Infused NRG Layer ",
        "Zero Motion Transfer for no partner disturbance",
      ],
    },
  ];

  const features = [
    "Dual Side usage",
    "Naturally Cooling Coir that refreshens you",
    "Firm back support",
    "Naturally Cooling Coir that refreshens you",
    "Firm back support",
  ];

  return (
    <section className="Reccomndation">
      <div className="container">
        <div className="main_div">
          <Common_Title title={"MAJESTY's Recommendation"} />

          <div className="all_cards_div">
            <div className="row ">
              {product?.length > 0 ? (
                product?.map((product) => {
                  let metal;
                  let size;
                  let triple;
                  if (
                    Number(product?.variant_type_id) ===
                    Number(variant_type.Single)
                  ) {
                    metal = product?.Product_Variants?.[0];
                  } else if (
                    Number(product?.variant_type_id) ===
                    Number(variant_type.Double)
                  ) {
                    metal = product?.Product_Variants?.[0];
                    size = metal?.Double_Variants?.[0];
                  } else if (
                    Number(product?.variant_type_id) ===
                    Number(variant_type.Triple)
                  ) {
                    metal = product?.Product_Variants?.[0];
                    size = metal?.Double_Variants?.[0];
                    triple = size?.Triple_Variants?.[0];
                  }

                  const activeVariant = triple || size || metal;

                  return (
                    <div className="col-xl-3 col-lg-4 col-sm-6 mb-5">
                      <Common_Product_Card
                        product={product}
                        id={product.id}
                        imgSrc={process.env.REACT_APP_IMG_URL + product.image}
                        vdoSrc={process.env.REACT_APP_IMG_URL + product.video}
                        productName={product.name}
                        sellingPrice={activeVariant?.price || 0}
                        mrp={activeVariant?.mrp || 0}
                        kgText={metal?.Metal?.name}
                        discount={
                          activeVariant?.mrp
                            ? (
                                ((parseFloat(activeVariant?.mrp || 0) -
                                  parseFloat(activeVariant?.price || 0)) /
                                  parseFloat(activeVariant?.mrp || 1)) *
                                100
                              ).toFixed(0)
                            : 0
                        }
                        feature={product?.Product_Fetures?.slice(0, 3)}
                        btnText={"Shop Now"}
                      />
                    </div>
                  );
                })
              ) : (
                <div
                  style={{
                    textAlign: "center",
                    padding: "20px",
                    fontWeight: "bold",
                    width: "100%",
                    color: "white",
                  }}
                >
                  Product Not Available
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Reccomndation;
